export { ApplicationsBarTitle } from './ApplicationsBarTitle';
